import axios from "axios";

const state = {
  bank_templates: [],
};

const getters = {
  bank_templates: (state) => state.bank_templates,
};

const actions = {
  async get_bank_templates({ commit }) {
    const response = await axios.get("bank_templates");
    commit("SET_BANK_TEMPLATES", response.data);
    return response.data;
  },

  async add_bank_template({ commit }, request) {
    const response = await axios.post("bank_template", request);
    commit("ADD_BANK_TEMPLATE", response.data);
    return response.data;
  },

  async edit_bank_template({ commit }, request) {
    const response = await axios.put("bank_template", request);
    commit("EDIT_BANK_TEMPLATE", response.data);
    return response.data;
  },

  async delete_bank_template({ commit }, id) {
    await axios.delete("bank_template/" + id);
    commit("DELETE_BANK_TEMPLATE", id);
  },
};

const mutations = {
  SET_BANK_TEMPLATES(state, templates) {
    state.bank_templates = templates;
  },

  ADD_BANK_TEMPLATE(state, template) {
    state.bank_templates.push(template);
    state.bank_templates.sort((a, b) =>
      a.template_name.localeCompare(b.template_name)
    );
  },

  EDIT_BANK_TEMPLATE(state, template) {
    const index = state.bank_templates.findIndex((t) => t.id == template.id);
    if (index !== -1) {
      state.bank_templates.splice(index, 1, template);
    }
  },

  DELETE_BANK_TEMPLATE(state, id) {
    state.bank_templates = state.bank_templates.filter((t) => t.id != id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
